import Locked from './Locked'

export default Locked
// eslint-disable-next-line import/export
export * from './Locked'
